import TestInfoForm from "./test-info-form";
import TestInfoSummary from "./test-info-summary";
import ProductInfoForm from "./product-info-form";
import ProductInfoSummary from "./product-info-summary";
import ProductCharacteristicsForm from "./product-characteristics-form";
import ProductCharacteristicsSummary from "./product-characteristics-summary";
import ExtraInfoForm from "./extra-info-form";
import ExtraInfoSummary from "./extra-info-summary";
import TestForm from "./test-form";
import TestSummary from "./test-summary";
import FactoryAssessmentForm from "./factory-assessment-form";
import FactoryAssessmentSummary from "./factory-assessment-summary";
import PhysicalInspectionForm from "./physical-inspection-form";
import PhysicalInspectionSummary from "./physical-inspection-summary";


export const formSteps = [
  {
    name: "Test Info",
    description: "Information about the factory acceptance test",
    accessor: "testInfo",
    FormComponent: TestInfoForm,
    SummaryComponent: TestInfoSummary,
  },
  {
    name: "Product Info",
    description: "Information about the product",
    accessor: "productInfo",
    FormComponent: ProductInfoForm,
    SummaryComponent: ProductInfoSummary,
  },
  {
    name: "Product Char.",
    description: "Information about product-specific characteristics",
    accessor: "productCharacteristics",
    FormComponent: ProductCharacteristicsForm,
    SummaryComponent: ProductCharacteristicsSummary,
  },
  {
    name: "Physical Insp.",
    description: "Information About the Physical Inspection",
    accessor: "physicalInspection",
    FormComponent: PhysicalInspectionForm,
    SummaryComponent: PhysicalInspectionSummary,
  },
  {
    name: "Test",
    description: "Information About the acceptanceTest Test",
    accessor: "test",
    FormComponent: TestForm,
    SummaryComponent: TestSummary,
  },
  {
    name: "Factory Ass.",
    description: "Information About the Factory Assessment",
    accessor: "factoryAssessment",
    FormComponent: FactoryAssessmentForm,
    SummaryComponent: FactoryAssessmentSummary,
  },
  {
    name: "Extra Info",
    description: "Additional Information About the Test",
    accessor: "extraInfo",
    FormComponent: ExtraInfoForm,
    SummaryComponent: ExtraInfoSummary,
  },
];

export default formSteps;
